import SidebarMenu from './SidebarMenu/SidebarMenu.vue';
import { useRoute } from 'vue-router';

export default {
  components: { SidebarMenu },
  computed: {
    activeTab(){
        const route = useRoute();
        return route.name;
    }
  }
};
